import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const CTASection = () => {
  return (
    <section className="py-24 lg:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="space-y-8"
        >
          <h2 className="text-5xl lg:text-6xl font-bold leading-tight text-gray-900">
            Build your membership and shop in one place
          </h2>

          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Launch memberships, post video and audio, sell digital products, and keep your biggest fans close with chat and community tools—all with simple, built-in payments.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/create"
              className="inline-flex items-center justify-center px-10 py-4 text-lg font-semibold text-white rounded-full transition-all duration-200 hover:opacity-90"
              style={{ background: "#FF424D" }}
            >
              Get started
            </Link>
            <Link
              to="/pricing"
              className="inline-flex items-center justify-center px-10 py-4 text-lg font-semibold text-gray-900 rounded-full border border-gray-300 hover:border-gray-400 transition-all duration-200"
            >
              View pricing
            </Link>
          </div>

          <p className="text-base text-gray-500">
            Already have an account?{" "}
            <Link
              to="/login"
              className="font-semibold hover:underline"
              style={{ color: "#FF424D" }}
            >
              Log in
            </Link>
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
